import { css } from "styled-components"
// import { BoxWrapper } from "../../map/map-point.style"
// import { SecondaryWrapper } from "../../bg-changer/bg-changer-wrapper.style"

const accentColor = " rgb(55, 254, 188)"

export const narrativesStyles = css`
   * { font-family: "Geologica"; }

  p {
    font-weight: 200;
    font-size: 18px;
    line-height: 33px;
  }

  [class^="cardstyle__CardBack"] p {
    font-size: 14px;
    @media screen and (min-width: ${(p) => p.theme.breakpointMobile}) { 
      font-size: 18px;
    }
  }

  .xnarratives-back-button {
    top: 32px;
    left: 0;
    width: 100%;
    position: absolute;
    text-align: center;
  }
  .xnarratives-back-button a {
    box-shadow: 3px 3px 0 color-mix(in srgb, #170a28,transparent 87.85%),  inset 0 0 2px color-mix(in srgb, #170a28,transparent 87.85%);
    font-family: Geologica, sans-serif;
    font-size: 18px;
    padding: 8px 16px;
    font-weight: 200;
    color: #362a48 !important;
    background-color: #fff;
  }
  .xnarratives-back-button a:hover {
    border: 0 !important;
    opacity: 0.75 !important;
  }

  .article-body-inner > div > h1 {
    color: rgb(54, 42, 72);
    font-size: 26px;
    font-weight: 600;
    padding-top: 20px;

    @media screen and (min-width: ${(p) => p.theme.breakpointMobile}) {    
      font-size: 36px;
      font-weight: 800;
      padding-top: 40px;
    }
  }

    .reading-progress-bar {
    background: rgb(55, 254, 188) !important;
  }

  .wp-block-separator:after {
    background-color: rgb(55, 254, 188) !important;
  }
  
  .tile-share, a.tile-share, .article-wrapper {
    background-color: rgb(55, 254, 188);
    box-shadow: 3px 3px 0 #362a48 !important;
    color: #362a48 !important;
    font-size: 15px;
    font-weight: 200;
    padding: 8px 16px;
  }

  .donation-encourager__button {
    background-color: rgb(55, 254, 188) !important;
    box-shadow: 3px 3px 0 #362a48 !important;
    color: #362a48 !important;
    font-size: 18px;
    font-weight: 700;
    padding: 8px 24px;
  }

  .subheading .toc-button-wrapper {
    display: none;
  }

  .donation-encourager__headline, .donation-encourager__lead-text{
    color: #362a48 !important;
  }

  .footnote p {
    font-family: "Geologica" !important;
    font-size: 0.8em;
  }

  
  a#footnote-link- {
    color: black;
  }
`

